import {removeStore, setStore} from "@/utils/store";

const mutations = {
    SET_MAJOR_TREE_LIST: (state, treeList = null) => {
        state.majorTreeList = treeList
        if (treeList && treeList.length > 0) {
            setStore({
                name: "majorTreeList",
                content: treeList
            })
        } else {
            removeStore({
                name: "majorTreeList",
            })
        }
    },
}

export default mutations
